import React, { useState } from 'react';
import { Button } from 'antd';
import s from './s.module.less';
import { handleSwitchToAccount } from 'utils/switchAccount';
import { trackHeapEvent } from 'utils/analytics';

type IProps = {
    isKlarityAccount?: boolean;
    onSwitchToAccount?: () => void;
};

const SwitchAccount = ({ isKlarityAccount = false, onSwitchToAccount }: IProps) => {
    const [loading, setLoading] = useState(false);

    const handleSwitchClick = async () => {
        setLoading(true);
        trackHeapEvent('WebApp - Switch Account - Click - Switch Account Attempt', {
            isKlarityAccount,
            targetAccount: isKlarityAccount ? 'Kiwi Health' : 'Klarity Health',
        });
        try {
            await handleSwitchToAccount(isKlarityAccount, onSwitchToAccount);
            trackHeapEvent('WebApp - Switch Account - View - Switch Account Success', {
                isKlarityAccount,
                targetAccount: isKlarityAccount ? 'Kiwi Health' : 'Klarity Health',
            });
        } catch (error) {
            trackHeapEvent('WebApp - Switch Account - View - Switch Account Error', {
                isKlarityAccount,
                targetAccount: isKlarityAccount ? 'Kiwi Health' : 'Klarity Health',
                error: error instanceof Error ? error.message : 'Unknown error',
            });
        } finally {
            setLoading(false);
        }
    };

    const title = isKlarityAccount ? 'Kiwi Health' : 'Klarity Health';
    const description = isKlarityAccount
        ? 'Access your Kiwi account to manage patients, appointments, and bookings.'
        : 'Access your Klarity account to manage patients, appointments, and bookings on Klarity Health.';

    const buttonText = isKlarityAccount ? 'Log in to Kiwi Health' : 'Log in to Klarity Health';
    const buttonClass = isKlarityAccount ? s.kiwiButton : s.klarityButton;

    return (
        <div className={s.wrap}>
            <h3 className={s.title}>{title}</h3>
            <p className={s.description}>
                {description}
            </p>
            <Button
                type="primary"
                className={buttonClass}
                onClick={handleSwitchClick}
                loading={loading}
            >
                {loading ? 'Switching...' : buttonText}
            </Button>
        </div>
    );
};

export default SwitchAccount;
